import {IOrpyxApplicationStore} from "../../store/application.reducers";

export const getAdminStoreState = (state: IOrpyxApplicationStore) => state.admin;
